import { TOUR_FLIGHT_SEARCH_FIXTURE } from 'checkout/fixtures/tourFlightSearch'
import { countOccupantsForFlights } from 'lib/offer/occupancyUtils'
import { defaultFareClass, FlightsFareTypes, FlightViewTypes } from 'constants/flight'
import { OFFER_TYPE_TOUR } from 'constants/offer'

const TOUR_FLIGHT_CUTOFF_TIME = '12:00'

const TOUR_FLIGHT_SEARCH_DEFAULTS = {
  fareClass: defaultFareClass,
  fareType: FlightsFareTypes.ONE_WAY,
  viewType: FlightViewTypes.ONE_WAY,
  source: OFFER_TYPE_TOUR,
} as const

/** Build the two searches from booked tour data, using fixture values only where needed. */
export function buildTourFlightSearch(tourItems: Array<App.Checkout.TourV2Item>, homeAirportCode?: string, tourAirports?: App.Tours.FlightAirports) {
  const rooms = tourItems.map(item => item.occupancy)
  const occupancies = rooms.length ? [countOccupantsForFlights(rooms)] : TOUR_FLIGHT_SEARCH_FIXTURE.departing.occupancies
  const tour = tourItems[0]
  const startDate = tour?.startDate ?? TOUR_FLIGHT_SEARCH_FIXTURE.departing.itinerary[0].departureDate

  return {
    departing: {
      ...TOUR_FLIGHT_SEARCH_DEFAULTS,
      maxArrivalTime: TOUR_FLIGHT_CUTOFF_TIME,
      itinerary: [{
        departureAirport: homeAirportCode ?? TOUR_FLIGHT_SEARCH_FIXTURE.departing.itinerary[0].departureAirport,
        arrivalAirport: tourAirports?.arrivalAirportCode ?? TOUR_FLIGHT_SEARCH_FIXTURE.departing.itinerary[0].arrivalAirport,
        departureDate: startDate,
        arrivalDate: startDate,
      }],
      occupancies,
    },
    returning: {
      ...TOUR_FLIGHT_SEARCH_DEFAULTS,
      minDepartureTime: TOUR_FLIGHT_CUTOFF_TIME,
      itinerary: [{
        departureAirport: tourAirports?.departureAirportCode ?? TOUR_FLIGHT_SEARCH_FIXTURE.returning.itinerary[0].departureAirport,
        arrivalAirport: homeAirportCode ?? TOUR_FLIGHT_SEARCH_FIXTURE.returning.itinerary[0].arrivalAirport,
        departureDate: tour?.endDate ?? TOUR_FLIGHT_SEARCH_FIXTURE.returning.itinerary[0].departureDate,
      }],
      occupancies,
    },
  }
}
